/* Launch countdown + signup segment (password page). One fixed instant; every visitor sees the same remaining time. */
(function () {
  if (!customElements.get('launch-countdown')) {
    customElements.define(
      'launch-countdown',
      class LaunchCountdown extends HTMLElement {
        connectedCallback() {
          this.target = Date.parse(this.dataset.target || '');
          this.units = {
            days: this.querySelector('[data-unit="days"]'),
            hours: this.querySelector('[data-unit="hours"]'),
            minutes: this.querySelector('[data-unit="minutes"]'),
            seconds: this.querySelector('[data-unit="seconds"]')
          };
          this.eyebrow = document.getElementById(this.dataset.eyebrow || '');
          if (isNaN(this.target)) {
            this.hidden = true;
            return;
          }
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const diff = this.target - Date.now();
          if (diff <= 0) {
            clearInterval(this.timer);
            this.hidden = true;
            if (this.eyebrow && this.dataset.doneText) this.eyebrow.textContent = this.dataset.doneText;
            return;
          }
          const pad = (n) => (n < 10 ? '0' : '') + n;
          this.units.days.textContent = pad(Math.floor(diff / 86400000));
          this.units.hours.textContent = pad(Math.floor(diff / 3600000) % 24);
          this.units.minutes.textContent = pad(Math.floor(diff / 60000) % 60);
          this.units.seconds.textContent = pad(Math.floor(diff / 1000) % 60);
        }
      }
    );
  }

  document.querySelectorAll('.newsletter-form__segment[data-tags-input]').forEach((fieldset) => {
    const tags = document.getElementById(fieldset.dataset.tagsInput);
    if (!tags) return;
    const base = tags.value;
    fieldset.querySelectorAll('input[name="segment"]').forEach((r) => (r.checked = false));
    fieldset.addEventListener('change', (e) => {
      if (e.target.name === 'segment' && e.target.value) tags.value = base + ', ' + e.target.value;
    });
  });
})();
